import { getTotalPrice } from '@shared/lib/money';
import * as React from 'react';
import { CartServiceProps } from '../types';
import ServiceSummary from '../../ServiceSummary';
import { useTranslation } from 'react-i18next';
import Aeroexpress from './Extra/Aeroexpress';
import Insurance from './Extra/Insurance';
import { useContext, useMemo } from 'react';
import { CartContext } from '../Cart';
import BusinessLounge from './Extra/BusinessLounge';
import Animal from './Extra/Animal';

import { ServiceSummaryType } from '../../ServiceSummary/types';
import { CheckoutSteps } from '../../MobileStepbar/types';
import TransferExtraCart from './Extra/Transfer';
import PriorityBoarding from './Extra/PriorityBoarding';
import BaggageDelivery from './Extra/BaggageDelivery';
import Sms from './Extra/Sms';
import Nas from './Extra/Nas';
import { CdnIcon } from '@shared/ui';
import RefundableTicket from './Extra/RefundableTicket';

const Extra: React.FC<CartServiceProps> = props => {
	const { t } = useTranslation('Cart');

	const { totalPrices } = useContext(CartContext);

	const prices = useMemo(() => {
		let prices = [
			totalPrices.aeroexpress,
			totalPrices.businessLounge,
			totalPrices.priorityBoarding,
			totalPrices.baggageDelivery,
			totalPrices.refundableTicket,
			totalPrices.sms,
			totalPrices.nas
		];

		if (!props.separateInsurance) {
			prices = [...prices, totalPrices.insurance];
		}

		if (props.separateAnimals) {
			prices = [...prices, totalPrices.animals];
		}

		return prices;
	}, [totalPrices, props.separateInsurance, props.separateAnimals]);

	const extraTotalPrice = useMemo(() => getTotalPrice(prices, price => price), [prices]);

	const hasExtraServices = useMemo(() => prices.some(price => price?.amount), [prices]);

	const group: ServiceSummaryType = {
		header: t('Extra'),
		icon: <CdnIcon icon={'Services/Insurance'} />,
		totalPrice: extraTotalPrice
	};

	const content = hasExtraServices ? (
		<>
			{totalPrices.aeroexpress !== null && <Aeroexpress {...props} />}
			{totalPrices.priorityBoarding !== null && <PriorityBoarding {...props} />}
			{totalPrices.transfer !== null && <TransferExtraCart {...props} />}
			{totalPrices.insurance !== null && !props.separateInsurance && <Insurance {...props} />}
			{totalPrices.businessLounge !== null && <BusinessLounge {...props} />}
			{totalPrices.animals !== null && <Animal {...props} />}
			{totalPrices.baggageDelivery !== null && <BaggageDelivery {...props} />}
			{totalPrices.sms !== null && <Sms {...props} />}
			{totalPrices.nas !== null && <Nas {...props} />}
			{totalPrices.refundableTicket !== null && <RefundableTicket {...props} />}
		</>
	) : null;

	if (props.renderService) {
		return props.renderService(CheckoutSteps.Extras, group, content);
	}

	if (!content) {
		return null;
	}

	return <ServiceSummary group={group}>{content}</ServiceSummary>;
};

export default Extra;
